const trainActionTypes = {
    DETAILS_FETCH_START: 'DETAILS_FETCH_START',
    DETAILS_FETCH_SUCCESS: 'DETAILS_FETCH_SUCCESS',
    DETAILS_FETCH_FAIL: 'DETAILS_FETCH_FAIL',
    SET_RAILYATRI_ID: 'SET_RAILYATRI_ID',
    SET_URL_DATA: 'SET_URL_DATA',
    SET_OFFSET: 'SET_OFFSET',
    SET_TYPE: "SET_TYPE",
    SET_IMAGES_BUG: "SET_IMAGES_BUG",
    SET_IMAGES_FEEDBACK: "SET_IMAGES_FEEDBACK",
    SET_BUG_TEXT: "SET_BUG_TEXT",
    SET_FEEDBACK_TEXT: "SET_FEEDBACK_TEXT",
    SEND_POST_START: "SEND_POST_START",
    SEND_POST_SUCCESS: "SEND_POST_SUCCESS",
    SEND_POST_FAIL: "SEND_POST_FAIL",
    LOGGED_IN: "LOGGED_IN",
}

export default trainActionTypes;